import MainLayout from 'MainLayout';
import React, { Suspense, useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { AdvisorAccessProvider } from '../../context/AdvisorAccessContext';
import { BreadcrumbsContext } from '../../context/BreadcrumbsContext';
import { FeatureProvider } from '../../context/FeatureContext';
import { CheckLoginComponent } from './CheckLoginComponent';
import LoadingSpinner from './LoadingSpinner';
import { AdvisorInvestorProvider, HomePage, InvestorProvider } from './nonAdminLazyImports';
import LookupOpportunity from './LookupOpportunity';
import LookupOpportunityAdvisor from './LookupOpportunityAdvisor';

export const LoginAndFundOpportunity = (props: { print?: boolean }) => (
  <LookupOpportunity type="FundOpportunity" print={props.print} />
);

export const LoginAndFundOpportunityUpdate = () => <LookupOpportunity type="FundUpdate" />;

export const AdvisorAndFundOpportunityUpdate = () => <LookupOpportunityAdvisor type="FundUpdate" />;

export const AdvisorAndFundOpportunity = (props: { print?: boolean }) => (
  <LookupOpportunityAdvisor type="FundOpportunity" print={props.print} />
);

export function HomePageWrapper() {
  const breadcrumbsContext = useContext(BreadcrumbsContext);
  return <HomePage breadcrumbsContext={breadcrumbsContext} />;
}

export function InvestorRouteWrapper() {
  return (
    <CheckLoginComponent initialiseAssetRead={true}>
      <Suspense fallback={<LoadingSpinner />}>
        <InvestorProvider key="investor-provider">
          <FeatureProvider>
            <AdvisorAccessProvider>
              <MainLayout>
                <Suspense fallback={<LoadingSpinner />}>
                  <Outlet />
                </Suspense>
              </MainLayout>
            </AdvisorAccessProvider>
          </FeatureProvider>
        </InvestorProvider>
      </Suspense>
    </CheckLoginComponent>
  );
}

export function ForwardRouteWrapper() {
  return (
    <CheckLoginComponent initialiseAssetRead={false}>
      <Outlet />
    </CheckLoginComponent>
  );
}

export function AdvisorInvestorRouteWrapper() {
  return (
    <CheckLoginComponent initialiseAssetRead={true}>
      <Suspense fallback={<LoadingSpinner />}>
        <AdvisorInvestorProvider key="advisor-investor-provider">
          <FeatureProvider>
            <AdvisorAccessProvider>
              <MainLayout>
                <Suspense fallback={<LoadingSpinner />}>
                  <Outlet />
                </Suspense>
              </MainLayout>
            </AdvisorAccessProvider>
          </FeatureProvider>
        </AdvisorInvestorProvider>
      </Suspense>
    </CheckLoginComponent>
  );
}
